<template>
  <div class="Page-conception3d">
    <!-- Hero Section -->
    <section class="Hero">
      <h1>Conception Modèles 3D</h1>
      <p class="Hero-subtitle">
        Modélisation professionnelle avec Blender, Fusion 360, Inventor et autres logiciels CAO.
      </p>
    </section>

    <!-- Services de conception -->
    <section class="Services">
      <h2>Nos Services de Conception 3D</h2>
      <div class="ServicesGrid">
        <div class="ServiceCard">
          <div class="ServiceIcon">🎨</div>
          <h3>Modélisation Artistique</h3>
          <p>Création de modèles 3D détaillés pour animation, jeux vidéo, ou rendu.</p>
          <ul>
            <li>Modèles organiques et stylisés</li>
            <li>Texturage et UV mapping</li>
            <li>Optimisation pour rendu</li>
            <li>Export dans divers formats</li>
          </ul>
        </div>
        <div class="ServiceCard">
          <div class="ServiceIcon">⚙️</div>
          <h3>Conception Technique</h3>
          <p>Modélisation précise pour ingénierie, prototypage et fabrication.</p>
          <ul>
            <li>Assemblages complexes</li>
            <li>Contraintes mécaniques intégrées</li>
            <li>Plans techniques et dessins</li>
            <li>Compatibilité impression 3D et CNC</li>
          </ul>
        </div>
        <div class="ServiceCard">
          <div class="ServiceIcon">🤝</div>
          <h3>Accompagnement & Formation</h3>
          <p>Support personnalisé pour maîtriser vos outils de modélisation.</p>
          <ul>
            <li>Formation Blender, Fusion 360, Inventor</li>
            <li>Conseils méthodologiques</li>
            <li>Optimisation workflow</li>
            <li>Assistance projets spécifiques</li>
          </ul>
        </div>
      </div>
    </section>

    <!-- Logiciels utilisés -->
    <section class="Softwares">
      <h2>Logiciels & Outils</h2>
      <div class="SoftwaresGrid">
        <div class="SoftwareCard">
          <div class="SoftwareIcon">🟦</div>
          <h3>Blender</h3>
          <p>Modélisation, animation, rendu photoréaliste.</p>
        </div>
        <div class="SoftwareCard">
          <div class="SoftwareIcon">🟧</div>
          <h3>Fusion 360</h3>
          <p>Conception paramétrique et fabrication assistée.</p>
        </div>
        <div class="SoftwareCard">
          <div class="SoftwareIcon">🟪</div>
          <h3>Autodesk Inventor</h3>
          <p>Ingénierie mécanique et conception industrielle.</p>
        </div>
        <div class="SoftwareCard">
          <div class="SoftwareIcon">🟩</div>
          <h3>SolidWorks</h3>
          <p>Modélisation 3D et simulation avancée.</p>
        </div>
      </div>
    </section>

    <!-- Processus de conception -->
    <section class="Process">
      <h2>Notre Processus de Conception 3D</h2>
      <div class="ProcessSteps">
        <div class="Step">
          <div class="StepNumber">1</div>
          <h3>Brief Client</h3>
          <p>Compréhension des besoins et contraintes.</p>
        </div>
        <div class="StepArrow">→</div>
        <div class="Step">
          <div class="StepNumber">2</div>
          <h3>Esquisse & Prototype</h3>
          <p>Modélisation initiale et validation.</p>
        </div>
        <div class="StepArrow">→</div>
        <div class="Step">
          <div class="StepNumber">3</div>
          <h3>Modélisation Finale</h3>
          <p>Création du modèle détaillé et optimisé.</p>
        </div>
        <div class="StepArrow">→</div>
        <div class="Step">
          <div class="StepNumber">4</div>
          <h3>Validation & Export</h3>
          <p>Contrôle qualité et export aux formats souhaités.</p>
        </div>
      </div>
    </section>

    <!-- Portfolio -->
    <section class="Portfolio">
      <h2>Exemples de Réalisations</h2>
      <div class="PortfolioGrid">
        <div class="PortfolioItem">
          <img src="@/assets/Images/pp.png" alt="Modèle Blender" />
          <h4>Modèle Blender</h4>
        </div>
        <div class="PortfolioItem">
          <img src="@/assets/Images/Fusion.png" alt="Conception Fusion 360" />
          <h4>Conception Fusion 360</h4>
        </div>
        <div class="PortfolioItem">
          <img src="@/assets/Images/Inventor.png" alt="Assemblage Inventor" />
          <h4>Assemblage Inventor</h4>
        </div>
        <div class="PortfolioItem">
          <img src="https://placehold.co/400x300?text=Simulation+SolidWorks" alt="Simulation SolidWorks" />
          <h4>Simulation SolidWorks</h4>
        </div>
      </div>
    </section>

    <!-- Contact -->
    <section class="Contact">
      <h2>Contactez-nous</h2>
      <p>Pour toute demande de conception 3D, devis ou formation, contactez notre équipe.</p>
      <div class="ContactButtons">
        <button class="ContactButton primary">Demander un Devis</button>
        <button class="ContactButton secondary">Nous Contacter</button>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'PageConception3D'
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@700;400&display=swap');

.Page-conception3d {
  min-height: 100vh;
  font-family: 'Montserrat', Arial, sans-serif;
  color: #fff;
}

/* Hero Section */
.Hero {
  text-align: left;
  padding: 4rem 2rem;
}
.Hero h1 {
  font-family: deonstudio;
  font-size: 3rem;
  margin-bottom: 1rem;
  color: var(--text-secondary);
}
.Hero-subtitle {
  font-size: 1.3rem;
  color: var(--text-muted);
  max-width: 600px;
  line-height: 1.6;
}

/* Services Section */
.Services {
  padding: 4rem 2rem;
  max-width: 1200px;
  margin: 0 auto;
}
.Services h2 {
  font-family: deonstudio;
  font-size: 2.5rem;
  text-align: center;
  margin-bottom: 3rem;
  color: var(--text-secondary);
}
.ServicesGrid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
  margin-bottom: 2rem;
}
.ServiceCard {
  background-color: var(--bg-tertiary);
  border-radius: var(--radius-small);
  padding: var(--spacing-lg);
  min-height: 320px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  transition: all var(--transition-normal);
  position: relative;
  overflow: hidden;
  box-shadow: 5px 5px 10px #d9d9d9, -5px -5px 10px #ffffff;
}
.ServiceCard:hover {
  transform: translateY(-8px);
  box-shadow: 0 8px 32px rgba(118, 153, 212, 0.2);
}
.ServiceIcon {
  font-size: 3rem;
  text-align: center;
  margin-bottom: 1rem;
  filter: grayscale(0.3);
}
.ServiceCard h3 {
  font-family: deonstudio;
  color: var(--text-secondary);
  font-size: 1.4rem;
  margin-bottom: 1rem;
  text-align: center;
}
.ServiceCard p {
  color: #bfc9e0;
  margin-bottom: 1.5rem;
  line-height: 1.6;
}
.ServiceCard ul {
  list-style: none;
  padding: 0;
}
.ServiceCard li {
  color: var(--text-muted);
  padding: 0.3rem 0;
  position: relative;
  padding-left: 1.5rem;
}
.ServiceCard li::before {
  content: "▸";
  color: var(--text-secondary);
  position: absolute;
  left: 0;
}

/* Softwares Section */
.Softwares {
  padding: 4rem 2rem;
  background-color: var(--bg-tertiary);
  border-radius: var(--radius-small);
  box-shadow: 5px 5px 10px #d9d9d9, -5px -5px 10px #ffffff;
  margin: 2rem 0;
}
.Softwares h2 {
  font-family: deonstudio;
  font-size: 2.5rem;
  text-align: center;
  margin-bottom: 3rem;
  color: var(--text-secondary);
}
.SoftwaresGrid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 2rem;
  max-width: 1000px;
  margin: 0 auto;
}
.SoftwareCard {
  background: white;
  border-radius: 12px;
  padding: 2rem;
  text-align: center;
  position: relative;
  transition: all 0.3s ease;
  border: 2px solid transparent;
}
.SoftwareCard:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(0,0,0,0.1);
}
.SoftwareIcon {
  font-size: 3rem;
  margin-bottom: 1rem;
}
.SoftwareCard h3 {
  font-family: deonstudio;
  color: var(--text-secondary);
  margin-bottom: 0.5rem;
}
.SoftwareCard p {
  color: #666;
  font-size: 0.95rem;
}

/* Process Section */
.Process {
  padding: 4rem 2rem;
  background-color: var(--bg-tertiary);
  border-radius: var(--radius-small);
  box-shadow: 5px 5px 10px #d9d9d9, -5px -5px 10px #ffffff;
}
.Process h2 {
  font-family: deonstudio;
  font-size: 2.5rem;
  text-align: center;
  margin-bottom: 3rem;
  color: var(--text-secondary);
}
.ProcessSteps {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 2rem;
  max-width: 1000px;
  margin: 0 auto;
}
.Step {
  text-align: center;
  flex: 1;
  min-width: 180px;
}
.StepNumber {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: var(--text-secondary);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  font-weight: bold;
  margin: 0 auto 1rem auto;
  font-family: deonstudio;
}
.Step h3 {
  font-family: deonstudio;
  color: var(--text-secondary);
  margin-bottom: 0.5rem;
}
.Step p {
  color: #bfc9e0;
  font-size: 0.9rem;
  line-height: 1.4;
}
.StepArrow {
  font-size: 2rem;
  color: var(--text-secondary);
  font-weight: bold;
}

/* Portfolio Section */
.Portfolio {
  padding: 4rem 2rem;
  max-width: 1200px;
  margin: 0 auto 3rem auto;
}
.Portfolio h2 {
  font-family: deonstudio;
  font-size: 2.5rem;
  text-align: center;
  margin-bottom: 3rem;
  color: var(--text-secondary);
}
.PortfolioGrid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
}
.PortfolioItem {
  background-color: var(--bg-tertiary);
  border-radius: var(--radius-small);
  overflow: hidden;
  box-shadow: 5px 5px 10px #d9d9d9, -5px -5px 10px #ffffff;
  text-align: center;
  transition: all 0.3s ease;
}
.PortfolioItem:hover {
  transform: translateY(-8px);
  box-shadow: 0 8px 32px rgba(118, 153, 212, 0.2);
}
.PortfolioItem img {
  width: 100%;
  height: auto;
  display: block;
}
.PortfolioItem h4 {
  font-family: deonstudio;
  color: var(--text-secondary);
  padding: 1rem 0;
}

/* Contact Section */
.Contact {
  padding: 4rem 2rem;
  background-color: var(--bg-tertiary);
  border-radius: var(--radius-small);
  box-shadow: 5px 5px 10px #d9d9d9, -5px -5px 10px #ffffff;
  text-align: center;
  max-width: 600px;
  margin: 0 auto 4rem auto;
}
.Contact h2 {
  font-family: deonstudio;
  font-size: 2.5rem;
  margin-bottom: 1rem;
  color: var(--text-secondary);
}
.Contact p {
  font-size: 1.1rem;
  margin-bottom: 2rem;
  color: var(--text-muted);
}
.ContactButtons {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
}
.ContactButton {
  border: none;
  padding: 1rem 2rem;
  font-size: 1.1rem;
  border-radius: 8px;
  cursor: pointer;
  font-family: deonstudio;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0,0,0,0.2);
}
.ContactButton.primary {
  background: var(--bg-secondary);
  color: white;
}
.ContactButton.secondary {
  background: transparent;
  color: var(--text-secondary);
  border: 2px solid var(--text-secondary);
}
.ContactButton:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0,0,0,0.3);
}
.ContactButton.primary:hover {
  background: var(--text-secondary);
}
.ContactButton.secondary:hover {
  background: var(--text-secondary);
  color: white;
}

/* Responsive amélioré */
@media (max-width: 1024px) {
  .ServicesGrid,
  .SoftwaresGrid,
  .PortfolioGrid {
    grid-template-columns: 1fr 1fr;
  }
}
@media (max-width: 768px) {
  .Hero {
    padding: 2rem 1rem;
  }
  .Hero h1 {
    font-size: 2rem;
  }
  .Hero-subtitle {
    font-size: 1rem;
  }
  .Services,
  .Softwares,
  .Process,
  .Portfolio,
  .Contact {
    padding: 2rem 1rem;
  }
  .ServicesGrid,
  .SoftwaresGrid,
  .PortfolioGrid {
    grid-template-columns: 1fr;
    gap: 1.2rem;
  }
  .ServiceCard,
  .SoftwareCard,
  .PortfolioItem {
    padding: 1.2rem;
    min-height: unset;
  }
  .ServiceCard:hover,
  .SoftwareCard:hover,
  .PortfolioItem:hover {
    transform: none;
    box-shadow: none;
  }
  .ProcessSteps {
    flex-direction: column;
    gap: 1.2rem;
  }
  .StepArrow {
    display: none;
  }
  .ContactButtons {
    flex-direction: column;
    gap: 1rem;
  }
  .ContactButton {
    width: 100%;
    min-width: 0;
    font-size: 1rem;
    padding: 0.8rem 1rem;
  }
}
@media (max-width: 480px) {
  .Hero h1 {
    font-size: 1.3rem;
  }
  .Hero-subtitle {
    font-size: 0.95rem;
  }
  .ServiceIcon,
  .SoftwareIcon {
    font-size: 2rem;
  }
  .ServiceCard,
  .SoftwareCard,
  .PortfolioItem {
    padding: 0.8rem;
  }
  .StepNumber {
    width: 40px;
    height: 40px;
    font-size: 1rem;
  }
  .Contact h2 {
    font-size: 1.2rem;
  }
  .ContactButton {
    font-size: 0.95rem;
    padding: 0.7rem 0.8rem;
  }
}
</style>